import type { FC } from 'react';
import { FormattedMessage } from 'react-intl';

import type { ButtonProps } from '@xing-com/button';
import { useShortNumber, THOUSAND } from '@xing-com/crate-social-utils';
import { IconComment } from '@xing-com/icons';

import { Styled } from './comment-counter.style';

export type CommentCounterProps = ButtonProps &
  CommentProps & {
    compact?: boolean;
    commentClick?: () => void;
    counter: number;
  };

type CommentProps = CommentAnchorProps | CommentLinkProps;

type CommentAnchorProps = {
  href?: string;
  to?: never;
};

type CommentLinkProps = {
  href?: never;
  to?: string;
};

export const CommentCounter: FC<CommentCounterProps> = ({
  compact = false,
  counter = 0,
  to,
  href,
  commentClick,
}) => {
  const { shortNumber } = useShortNumber(counter);

  return (
    // @ts-expect-error FIXME: SC6
    <Styled.CommentCounter
      compact={compact}
      data-testid="comment-counter"
      fontWeight="regular"
      href={href}
      icon={compact ? IconComment : undefined}
      onClick={commentClick}
      size="small"
      to={to}
    >
      {compact ? (
        shortNumber
      ) : counter < THOUSAND ? (
        <FormattedMessage
          id="SOCIAL_COMMENTS_COUNTER_LABEL"
          values={{ counter }}
        />
      ) : (
        <FormattedMessage
          id="SOCIAL_COMMENT_COUNTER_LABEL"
          values={{ amount: shortNumber }}
        />
      )}
    </Styled.CommentCounter>
  );
};
